import styled, { css } from 'styled-components';
import media from '../../../constants/media';
import theme from '../../../constants/theme';
import { Column } from '../../base/grid';
import { A } from '../../base/typography';

export const LeftColumn = styled(Column)`
	width: 55%;
	padding: 10rem 25rem 10rem 15rem;

	strong {
		font-weight: bold;
		color: ${theme.colors.black};
	}

	label {
		margin: 0.5rem 0;
		font-size: 1.6rem;
		font-weight: normal;
		color: ${theme.colors.black};
	}

	button {
		width: 100%;
		margin-top: 4rem;
	}

	${media.desktopSmallOnly`
    	padding: 10rem 15rem 5rem 0;
    `}

	${media.tabletOnly`
    	padding: 10rem 10rem 5rem 0;
    `}

    ${media.mobileOnly`
    	width: 100%;
    	padding: 5rem 5rem 0 5rem;

    	a { float: left; }
    `}
`;

export const LinkCard = styled(A)`
	display: flex;
	flex-direction: column;
	width: 100%;
	box-shadow: 0px 11px 24px #ececec;
	padding: 2rem 4rem 2rem 3rem;
	font-family: ${theme.fonts.ArimoRegular};
	color: ${theme.colors.gray} !important;
	margin-bottom: 2rem;

	div:first-child {
		color: ${theme.colors.black};
		font-weight: bold;
	}

	div:last-child {
		display: inline;
		align-self: flex-end;
		svg {
			width: 2rem;
			color: ${theme.colors.primary};
		}
		margin-right: -2rem;
	}

	${({ border }) =>
		border &&
		`
	    border: 1px solid ${theme.colors.secondary};
	`}
`;

export const InfoText = styled.div`
	margin: 3rem 0;

	${({ checkbox }) =>
		checkbox &&
		`
	    margin-bottom: 1.5rem;
	`}
`;

export const Steps = styled(Column)`
	width: 45%;
	background-color: ${theme.colors.grayLighter};
	padding: 5rem 0;

	${media.mobileOnly`
        pointer-events: none;
    	width: 100%;
    	background-color: transparent;
    	padding: 0 5rem;

        && > div {
            display: inline-block;
            float: right;
        }
    `}
`;

export const SkipLink = styled(A)`
	margin-bottom: -4rem;
	color: ${theme.colors.secondary};
	float: right;
	margin-top: 3rem;
	font-size: 1.6rem;
	&&:hover {
		color: ${theme.colors.secondaryDark};
	}

	${({ logout }) =>
		logout &&
		`
		color: ${theme.colors.primary};
		&&:hover { color: ${theme.colors.primaryDark}; }
	`}
`;

export const Step = styled.div`
	display: flex;
	align-items: center;
	margin-top: 5rem;
	color: rgba(0, 0, 0, 0.2);

	${({ active }) =>
		active &&
		css`
			color: ${theme.colors.gray};
		`}

	${media.mobileOnly`
	    display: inline-block;
	    margin: 0 0 0 1rem;
	`}
`;

export const Bubble = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: white;
	border-radius: 100%;
	width: 5rem;
	height: 5rem;
	margin: 0 4rem 0 -2.25rem;
	font-weight: bold;
	box-shadow: 0px 2px 34px rgba(0, 0, 0, 0.07);
	color: ${theme.colors.gray};

	${({ active }) =>
		active &&
		css`
			background-color: ${theme.colors.primary};
			color: white;
		`}

	${({ fulfilled }) =>
		fulfilled &&
		css`
			background-color: ${theme.colors.secondary};
			color: white;
			cursor: pointer;
		`}

    ${media.mobileOnly`
        height: 2rem;
        width: 2rem;
        background-color: ${theme.colors.grayLight};
        margin: 0;
        color: transparent;

        ${({ active }) =>
			active &&
			css`
				background-color: ${theme.colors.primary};
			`}
    `}
`;

export const BubbleText = styled.div`
	width: 50%;
	font-size: 1.6rem;

	${media.mobileOnly`
        display: none;
    `}
`;

export const BubbleHeading = styled.div`
	font-weight: bold;
	font-size: 2.2rem;
	margin-bottom: 0.2rem;
`;
